export default {"src":"/_next/static/media/speak-no-evil.548dbc46.svg","height":21,"width":21};